export const ENV = {
  // Node Env
  mode: import.meta.env.MODE as 'development' | 'staging' | 'production',
  isDevelopment: import.meta.env.MODE === 'development',
  isStaging: import.meta.env.MODE === 'staging',
  isProduction: import.meta.env.MODE === 'production',

  // FE
  frontendApiUrl: import.meta.env.VITE_FRONTEND_API_URL,
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  mapboxPublicToken: import.meta.env.VITE_MAPBOX_PUBLIC_TOKEN,
  bugsnagApiKey: import.meta.env.VITE_BUGSNAG_API_KEY,
  clarityProjectId: import.meta.env.VITE_CLARITY_PROJECT_ID as
    | string
    | undefined,

  // BE
  backendApiUrl: import.meta.env.VITE_BACKEND_API_URL,
} as const;
